export const FB_LINK = `https://www.facebook.com/people/CollegeHaicom/61569045170070/#`;

export const WA_LINK = ``;
export const IG_LINK = `https://www.instagram.com/collegehaiindia/profilecard/?igsh=NWt3aWUwZWtjcmtz`;
export const LINKEDIN_LINK = `https://www.linkedin.com/company/collegehai`;
export const YT_LINK = `https://www.youtube.com/@collegehai`;
export const TWITTER_LINK = `https://x.com/collegehaiindia`;
export const INSTA_LINK = `https://www.instagram.com/collegehaiindia/`;

export const domain_url = process.env.NEXT_PUBLIC_DOMAIN_URL;

export const baseUrl = process.env.NEXT_PUBLIC_DOMAIN_URL?.replace(/\/$/, '');

export const image_base_url = `/uploads`;
